// extracted by mini-css-extract-plugin
module.exports = {"filter_pricing":"FilterPricing_filter_pricing__2uP6T","select":"FilterPricing_select__2Y67-","apply_btn":"FilterPricing_apply_btn__2GrCK"};